import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import da from './locales/da.json';
import de from './locales/de.json';
import sv from './locales/sv.json';
import no from './locales/no.json';
import nl from './locales/nl.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import fi from './locales/fi.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      da: { translation: da },
      de: { translation: de },
      sv: { translation: sv },
      no: { translation: no },
      nl: { translation: nl },
      fr: { translation: fr },
      es: { translation: es },
      fi: { translation: fi },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'da', 'de', 'sv', 'no', 'nl', 'fr', 'es', 'fi'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
